<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return { publicPath: process.env.BASE_URL || '/' }
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.home">
      <img
        :src="`${publicPath}rappilogoorange.png`"
        :class="$style.logo"
        alt="Rappi"
      >
    </div>
  </Layout>
</template>

<style lang="scss" module>
.home {
  display: flex;
  justify-content: center;
  padding-top: 6rem;
}

.logo {
  width: 160px;
  max-width: 60%;
  height: auto;
}
</style>
